import type { StoryTemplate } from '@plush-book/shared';
import sleepStar from './sleep_star.json' with { type: 'json' };
import littleBigAdventure from './little_big_adventure.json' with { type: 'json' };
import birthdaySurprise from './birthday_surprise.json' with { type: 'json' };

export const STORY_TEMPLATES: StoryTemplate[] = [
  sleepStar as StoryTemplate,
  littleBigAdventure as StoryTemplate,
  birthdaySurprise as StoryTemplate,
];

export const STORY_TEMPLATES_BY_ID: Record<string, StoryTemplate> = Object.fromEntries(
  STORY_TEMPLATES.map((t) => [t.id, t]),
);

export function getStoryTemplate(id: string): StoryTemplate | undefined {
  return STORY_TEMPLATES_BY_ID[id];
}
